import React from 'react';
import { UseFormRegister, UseFormReturn, UseFormWatch } from 'react-hook-form';
import { AddressForm, AddressTypes, FormValidation } from '../../global-types/addresses';
import { RegionalSchema } from '../../regional-config/regional-config-types';
import { SubmittedAddresses } from '../../views/address/address-types';
import { ActionButtonProps, SecondaryActionButtonProps } from '../navigation-buttons/navigation-buttons-types';

export type NavigationProps = {
  secondaryActionButton: SecondaryActionButtonProps;
  primaryActionButton: ActionButtonProps;
};

export type AddressFormFooterButtonsProps = {
  oneToOneProps: NavigationProps;
  oneToManyProps: NavigationProps;
};

export type GetAddressesProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isLoading: boolean;
};

export type AddressFormProps = {
  addressType: AddressTypes;
  addClass?: string;
  /** All the return values from the useForm hook */
  formHandlers: UseFormReturn<AddressForm>;
  mockConfig?: RegionalSchema;
  isLoadingAddresses: boolean;
  getNextPage: () => void;
  onSkipValidation: (addressesToValidate: FormValidation[]) => void;
  setSubmittedAddresses: React.Dispatch<React.SetStateAction<SubmittedAddresses>>;
  setShouldSave: (shouldSave: boolean) => void;
  getAddressesProps: GetAddressesProps;
  footerButtonsProps: AddressFormFooterButtonsProps;
};

export type AddressFormActions = {
  isValid: boolean;
  isTouched: boolean;
  isAddressLoading: boolean;
  isAddressFormValid: boolean;
  submitLabel: string;
  goBack: () => void;
  goNext: () => void;
  onHandleLeaveRemainingBlank: () => void;
  goPreviousAddress: () => void;
};

export type AddressBookButtonProps = {
  click: () => void;
};

export type CollapseSectionProps = {
  children: React.ReactNode;
};

export type EnvelopeRadioGroupProps = {
  /** The method from react-hook-form to register the radio cards to the form */
  register: UseFormRegister<AddressForm>;
  watch: UseFormWatch<AddressForm>;
};

export type EnvelopeFormHeaderProps = {
  formTitle: string;
};

export enum DeliveryModes {
  MailToRecipient = 'M',
  ShipToMe = 'S',
  None = '',
}

export type UsStateData = {
  code: string;
  desc: string;
  display_indicator: boolean;
};

export type UsStateOptions = {
  value: string;
  label: string;
};
